export const isElementInViewPortVertical = input => {
  const { element, bottomOffset = 0 } = input;
  if (element && element.getBoundingClientRect) {
    const rect = element.getBoundingClientRect();

    return (
      rect.top >= 68 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) +
          bottomOffset
    );
  }
  return true;
};
